import { useCallback } from "react";

import { StartedDialogue } from "@/features/socratic/types";
import { useStartSocraticDialogueMutation } from "@/generated/graphql";

export const useStartDialogue = () => {
  const [mutation, { loading, data, error }] =
    useStartSocraticDialogueMutation();

  const startDialogue = useCallback(
    ({ workId, dialogueId }: { workId: string; dialogueId: string }) => {
      return mutation({
        variables: {
          workId,
          dialogueId,
        },
      });
    },
    [mutation]
  );

  const startedDialogue: StartedDialogue | null = data?.startSocraticDialogue
    .dialogue?.startedAt
    ? (data.startSocraticDialogue.dialogue as StartedDialogue)
    : null;

  const startError = data?.startSocraticDialogue.error || error;

  return {
    startDialogue,
    startedDialogue,
    isStartingDialogue: loading,
    isStartError: !!startError,
    startError: startError,
  };
};
